import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductExperience } from '../components/ProductExperience';
import { CompetitiveEdge } from '../components/CompetitiveEdge';
import { CaseStudy } from '../components/CaseStudy';
import { LeadershipSection } from '../components/LeadershipSection';
import { FinalCTA } from '../components/FinalCTA';
import { SiteFooter } from '../components/ui/SiteFooter';
export function FemEntityLanding() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-462" data-mp="rv1lbwxt2psg">
      {/* Navigation placeholder - minimal for landing page */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-463" data-mp="my1jxzbwib7o">
        <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-464" data-mp="37mfqq0c4m33g" />
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-465" data-mp="3j134g4yu171o">
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-466" data-mp="3iyqrk67xlmvh">
            Get the App
          </a>
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-467" data-mp="39z3n1bjwo0y7">
            Practitioners
          </a>
        </div>
      </nav>

      <Hero data-id="element-468" data-mp="3038zq34qlhp3" />
      <ProblemSection data-id="element-469" data-mp="3030mga4pcadd" />
      <CaseStudy data-id="element-470" data-mp="304bpg7qbpe3f" />
      <SolutionSection data-id="element-471" data-mp="2mastktgjh3jy" />
      <ProductExperience data-id="element-472" data-mp="2mbc8s2et1dua" />
      <CompetitiveEdge data-id="element-473" data-mp="2mc3tujarzt6b" />
      <LeadershipSection data-id="element-474" data-mp="2m8ptfglo9u1i" />
      <FinalCTA data-id="element-475" data-mp="2r9nlqm0ec4gq" />

      <SiteFooter currentPath="/" data-id="element-476" data-mp="2r942n1z0fa14" />
    </main>;
}